import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import "./css/LayoutUsuarioPage.css"
import useNoIndex from "../shared/hooks/useNoIndex";
import IconHome from "../components/icons/IconHome";
import IconInventory from "../components/icons/IconInventory";
import IconAccountCircle from "../components/icons/IconAccountCircle";
import IconHomeWork from "../components/icons/IconHomeWork";
import IconVisibilityOn from "../components/icons/IconVisibilityOn";
import IconFavorite from "../components/icons/IconFavorite";
import IconLoyalty from "../components/icons/IconLoyalty";
import IconReceiptLong from '../components/icons/IconReceiptLong';
import IconSettings from "../components/icons/IconSettings";
import IconHelp from "../components/icons/IconHelp";
import IconLogout from "../components/icons/IconLogout";
import IconKeyBoardArrowDown from "../components/icons/IconKeyboardArrowDown";
import useIcons from "../shared/hooks/useIcons";
import useUsuarioHandler from '../redux/handler/useUsuarioHandler';



const LayoutUsuarioPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    useNoIndex()
    const getIcon = useIcons()
    const [loged, setLoged] = useState(false)
    const [menuSeleccionado, setMenuSeleccionado] = useState("Inicio")
    const [menuSeleccionadoIcono, setMenuSeleccionadoIcono] = useState("home")
    const [mostrarMenuMovil, setMostrarMenuMovil] = useState(false)

    const { usuario } = useUsuarioHandler();

    const HandleLink = async (nombreMenu, icono) => {
        setMostrarMenuMovil(false)
        setMenuSeleccionado(nombreMenu)
        setMenuSeleccionadoIcono(icono)
    }

    useEffect(() => {
        if (usuario.IsLogged) {
            setLoged(true)
        } else {
            navigate("/login")
        }

        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        window.scrollTo(0, 0)

        let myLocation = window.location.href.toLocaleLowerCase()
        if (myLocation.includes("usuario")) { setMenuSeleccionado("Inicio") }
        if (myLocation.includes("/pedidos")) { setMenuSeleccionado("Mis pedidos") }
        if (myLocation.includes("/cuenta")) { setMenuSeleccionado("Mi cuenta") }
        if (myLocation.includes("/direccion")) { setMenuSeleccionado("Mis direcciones") }
        if (myLocation.includes("/productos_historial")) { setMenuSeleccionado("Productos vistos") }
        if (myLocation.includes("/favoritos")) { setMenuSeleccionado("Mis favoritos") }
        if (myLocation.includes("/codigos")) { setMenuSeleccionado("Codigo de descuento") }
        if (myLocation.includes("/ordenes_trabajo")) { setMenuSeleccionado("Ordenes de Trabajo") }
        if (myLocation.includes("/configuracion")) { setMenuSeleccionado("Configuracion") }
    }, [location])
    return (
        <>
            {loged
                ? <div className="container-usuario-home-background">
                    <div className="container">
                        <div className="container-usuario-home" >
                            <div className="usuario-home-menu no-select">
                                <div >
                                    <div className={menuSeleccionado === "Inicio" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Inicio", "home") }} to="/usuario">
                                            <IconHome width={23.75} heigth={24} fill={"#808080"} />
                                            Inicio
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Mis pedidos" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Mis pedidos", "inventory") }} to="/usuario/pedidos">
                                            <IconInventory width={23.75} heigth={24} fill={"#808080"} />
                                            Mis Pedidos
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Mi cuenta" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Mi cuenta", "account_circle") }} to="/usuario/cuenta">
                                            <IconAccountCircle width={23.75} heigth={24} fill={"#808080"} />
                                            Mi Cuenta
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Mis direcciones" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Mis direcciones", "home_work") }} to="/usuario/direccion">
                                            <IconHomeWork width={23.75} heigth={24} fill={"#808080"} />
                                            Mis direcciones
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Productos vistos" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Productos vistos", "visibility") }} to="/usuario/productos_historial">
                                            <IconVisibilityOn width={23.75} heigth={24} fill={"#808080"} />
                                            Productos vistos
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Mis favoritos" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Mis favoritos", "favorite") }} to="/usuario/favoritos">
                                            <IconFavorite width={23.75} heigth={24} fill={"#808080"} />
                                            Mis favoritos
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Codigo de descuento" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Codigo de descuento", "loyalty") }} to="/usuario/codigos">
                                            <IconLoyalty width={23.75} heigth={24} fill={"#808080"} />
                                            Códigos de descuento
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Ordenes de Trabajo" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Ordenes de Trabajo", "receipt_long") }} to="/usuario/ordenes_trabajo">
                                            <IconReceiptLong width={23.75} heigth={24} fill={"#808080"} />
                                            Órdenes de trabajo
                                        </Link>
                                    </div>
                                    <div className={menuSeleccionado === "Configuracion" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Configuracion", "settings") }} to="/usuario/configuracion">
                                            <IconSettings width={23.75} heigth={24} fill={"#808080"} />
                                            Configuración
                                        </Link>
                                    </div>
                                    <div style={{ display: "none" }} className={menuSeleccionado === "Ayuda" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Ayuda", "help") }} to="/usuario/ayuda">
                                            <IconHelp width={23.75} heigth={24} fill={"#808080"} />
                                            Ayuda
                                        </Link>
                                    </div>
                                    <hr />
                                    <div className={menuSeleccionado === "Cerrar sesion" ? "menu-pc-resaltado" : ""}>
                                        <Link onClick={() => { HandleLink("Cerrar sesion", "logout") }} to="/usuario/logout">
                                            <IconLogout width={23.75} heigth={24} fill={"#808080"} />
                                            Cerrar sesión
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="usuario-home-content">
                                <div className="usuario-home-movil no-select">
                                    <div className={"usuario-homecollapse-menu "} style={(mostrarMenuMovil ? { display: "none" } : { display: "flex", border: "1px solid #f0761d", background: "#f0761d24" })} onClick={() => {
                                        setMostrarMenuMovil(!mostrarMenuMovil)
                                    }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {getIcon(menuSeleccionadoIcono)}
                                            <p style={{ padding: "0", margin: "0", marginLeft: "15px" }}>{menuSeleccionado}</p>
                                        </div>

                                        <IconKeyBoardArrowDown width={23.75} heigth={23.4} fill={"#808080"} />
                                    </div>
                                    <div className={"usuario-homecollapse-content"} style={(mostrarMenuMovil ? { display: "block" } : { display: "none" })}>
                                        <div className={menuSeleccionado === "Inicio" ? "menu-movil-resaltado" : ""} >
                                            <Link onClick={() => { HandleLink("Inicio", "home") }} to="/usuario">
                                                <IconHome width={23.75} heigth={24} fill={"#808080"} />
                                                Inicio
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Mis pedidos" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Mis pedidos", "inventory") }} to="/usuario/pedidos">
                                                <IconInventory width={23.75} heigth={24} fill={"#808080"} />
                                                Mis pedidos
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Mi cuenta" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Mi cuenta", "account_circle") }} to="/usuario/cuenta">
                                                <IconAccountCircle width={23.75} heigth={24} fill={"#808080"} />
                                                Mi cuenta
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Mis direcciones" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Mis direcciones", "home_work") }} to="/usuario/direccion">
                                                <IconHomeWork width={23.75} heigth={24} fill={"#808080"} />
                                                Mis direcciones
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Productos vistos" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Productos vistos", "visibility") }} to="/usuario/productos_historial">
                                                <IconVisibilityOn width={23.75} heigth={24} fill={"#808080"} />
                                                Productos vistos
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Mis favoritos" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Mis favoritos", "favorite") }} to="/usuario/favoritos">
                                                <IconFavorite width={23.75} heigth={24} fill={"#808080"} />
                                                Mis favoritos
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Codigo de descuento" ? "menu-pc-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Codigo de descuento", "loyalty") }} to="/usuario/codigos">
                                                <IconLoyalty width={23.75} heigth={24} fill={"#808080"} />
                                                Codigo de descuento
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Ordenes de Trabajo" ? "menu-pc-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Ordenes de Trabajo", "receipt_long") }} to="/usuario/ordenes_trabajo">
                                                <IconReceiptLong width={23.75} heigth={24} fill={"#808080"} />
                                                Órdenes de trabajo
                                            </Link>
                                        </div>
                                        <div className={menuSeleccionado === "Configuracion" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Configuracion", "settings") }} to="/usuario/configuracion">
                                                <IconSettings width={23.75} heigth={24} fill={"#808080"} />
                                                Configuración
                                            </Link>
                                        </div>
                                        <div style={{ display: "none" }}>
                                            <Link onClick={() => { HandleLink("Ayuda", "help") }} to="/usuario/ayuda">
                                                <IconHelp width={23.75} heigth={24} fill={"#808080"} />
                                                Ayuda
                                            </Link>
                                        </div>
                                        <hr />
                                        <div className={menuSeleccionado === "Cerrar sesion" ? "menu-movil-resaltado" : ""}>
                                            <Link onClick={() => { HandleLink("Cerrar sesión", "logout") }} to="/usuario/logout">
                                                <IconLogout width={23.75} heigth={24} fill={"#808080"} />
                                                Cerrar sesión
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
                : <></>}

        </>
    )

}
export default LayoutUsuarioPage